
export default {
    // @TSL
    setNewCreatedTSL(state, value){
        state.newCreatedTSL = value
    },
}